import { useMutation } from '@apollo/client'

import {
  UpdateOrderDetailsEventAndTypeDocument,
  UpdateOrderDetailsEventAndTypeMutation,
  UpdateOrderDetailsEventAndTypeMutationVariables,
  UpdateOrderDetailsWarehouseAndSeasonDocument,
  UpdateOrderDetailsWarehouseAndSeasonMutation,
  UpdateOrderDetailsWarehouseAndSeasonMutationVariables,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  mutation UpdateOrderDetailsEventAndType($orderInfoInput: UpdateOrderInfoInput) {
    updateOrderInfo(input: $orderInfoInput) {
       orders {
          edges {
            node {
              id
              event {
                id
                name
                code
              }
              types {
                id
                name
                code
              }
            }
          }
        }   
      errors
    }
  }
`

atlas`#graphql
  mutation UpdateOrderDetailsWarehouseAndSeason($input: UpdateOrderDeliveryInfoInput!) {
    updateOrderDeliveryInfo(input: $input) {
      orders {
        edges {
          node {
            id
            warehouses {
              edges {
                node {
                  id
                  name
                  code
                }
              }
            }
            season {
              id
              name
              code
              year
            }
          }
        }
      }
    }
  }
`

export function useUpdateEventAndType() {
  return useMutation<
    UpdateOrderDetailsEventAndTypeMutation,
    UpdateOrderDetailsEventAndTypeMutationVariables
  >(UpdateOrderDetailsEventAndTypeDocument, {
    client: atlasClient,
  })
}

export function useUpdateWarehouseAndSeason() {
  return useMutation<
    UpdateOrderDetailsWarehouseAndSeasonMutation,
    UpdateOrderDetailsWarehouseAndSeasonMutationVariables
  >(UpdateOrderDetailsWarehouseAndSeasonDocument, {
    client: atlasClient,
  })
}
